<template lang="pug">
  vue-slider(ref="slider3" v-bind="demo.demo3" v-model="demo.demo3.value")
</template>

<script>
import vueSlider from 'vue-slider-component'

export default {
  components: {
    vueSlider
  },
  data: () => ({
    demo: {
      demo3: {
        value: [ 0, 100 ],
        width: '80%',
        height: 5,
        dotSize: 16,
        min: 0,
        max: 500,
        show: true,
        useKeyboard: true,
        tooltip: 'always',
        enableCross: true,
        bgStyle: {
          backgroundColor: '#fff',
          boxShadow: 'inset 0.5px 0.5px 3px 1px rgba(0,0,0,.36)'
        },
        tooltipStyle: {
          backgroundColor: '#666',
          borderColor: '#666'
        },
        processStyle: {
          backgroundColor: '#999'
        }
      }
    }
  })
}
</script>
